import React from 'react';
import './tag.css';
import { TagGroup, Tag, IconButton } from 'rsuite';
import PlusIcon from '@rsuite/icons/Plus';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomInput } from '../CustomInput';

const normalize = (value) =>
  value
    .normalize('NFD')
    .replace(/\p{Mn}/gu, '')
    .toLowerCase()
    .trim();

const TagRender = ({ valuesArray, onChange }) => {
  const [typing, setTyping] = React.useState(false);
  const [inputValue, setInputValue] = React.useState('');
  const { theme } = useCustomTheme();

  const tags = Array.isArray(valuesArray) ? valuesArray : [];

  const removeTag = (tag) => {
    onChange(tags.filter((item) => item !== tag));
  };

  const addTag = () => {
    const normalized = normalize(inputValue || '');
    if (normalized && !tags.includes(normalized)) {
      onChange([...tags, normalized]);
    }
    setTyping(false);
    setInputValue('');
  };

  const handleButtonClick = () => setTyping(true);

  const renderInput = () => {
    if (typing) {
      return (
        <CustomInput
          autoFocus
          className="tag-input"
          size="xs"
          style={{ width: 160 }}
          value={inputValue}
          placeholder="Digite e pressione Enter"
          onChange={setInputValue}
          onBlur={addTag}
          onPressEnter={addTag}
        />
      );
    }

    return (
      <IconButton
        className="tag-add-btn"
        onClick={handleButtonClick}
        icon={<PlusIcon />}
        appearance="ghost"
        size="xs"
        style={{
          borderColor: theme.colors.primary,
          color: theme.colors.primary,
        }}
      >
        Adicionar
      </IconButton>
    );
  };

  return (
    <div style={{ padding: '5px' }}>
      <TagGroup>
        <div style={{ margin: '10px 5px' }}>
          {tags.map((item, index) => (
            <Tag
              key={`${item}-${index}`}
              style={{
                backgroundColor: theme.colors.primary,
                color: theme.colors.white,
              }}
              closable
              onClose={() => removeTag(item)}
            >
              {item}
            </Tag>
          ))}
          {renderInput()}
        </div>
      </TagGroup>
    </div>
  );
};

export default TagRender;
